import { SIGMA_PFA_TABS, type SigmaTab } from '@trinity/management-app-client';

export type { SigmaTab } from '@trinity/management-app-client';

/** Which optional Sigma tabs are shown. Unset means off. */
export type SigmaTabFlags = {
  includeTreatmentClaimCount?: boolean;
  includeEpidemiology?: boolean;
  includeLineOfTherapy?: boolean;
  includeCompliance?: boolean;
  includePersistence?: boolean;
};

export type SigmaTabDefinition = { key: SigmaTab; label: string };

export const isSigmaPfaTab = (tab: SigmaTab): boolean => SIGMA_PFA_TABS.includes(tab);

/** The tabs a Sigma dashboard shows: the four always there, then each optional one that is switched on. */
export const getSigmaTabs = (flags: SigmaTabFlags): SigmaTabDefinition[] => [
  { key: 'patient_count', label: 'Patient Count' },
  { key: 'hcp_count', label: 'HCP Count' },
  { key: 'hcp_universe', label: 'HCP Universe' },
  { key: 'hcp_profile', label: 'HCP Profile' },
  ...(flags.includeTreatmentClaimCount
    ? [{ key: 'treatment_claim_count' as const, label: 'Treatment Claim Count' }]
    : []),
  ...(flags.includeEpidemiology ? [{ key: 'epidemiology' as const, label: 'Epidemiology' }] : []),
  ...(flags.includeLineOfTherapy ? [{ key: 'line_of_therapy' as const, label: 'Line of Therapy' }] : []),
  ...(flags.includeCompliance ? [{ key: 'compliance' as const, label: 'Compliance' }] : []),
  ...(flags.includePersistence ? [{ key: 'persistence' as const, label: 'Persistence' }] : []),
];
